import { render, staticRenderFns } from "./DocumentosInscripcionesVer.vue?vue&type=template&id=ba543c36&scoped=true"
import script from "./DocumentosInscripcionesVer.vue?vue&type=script&lang=js"
export * from "./DocumentosInscripcionesVer.vue?vue&type=script&lang=js"
import style0 from "./DocumentosInscripcionesVer.vue?vue&type=style&index=0&id=ba543c36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba543c36",
  null
  
)

export default component.exports